import { Inbox } from "lucide-react";

export default function EmptyState({ title, body, action }) {
  return (
    <div className="card-flat p-10 flex flex-col items-center text-center animate-fadeup">
      <div className="h-14 w-14 rounded-full bg-[var(--bg-accent)] flex items-center justify-center text-[var(--accent-primary)]">
        <Inbox size={22} />
      </div>
      <div className="mt-4 font-medium text-lg" style={{fontFamily:'var(--font-heading)'}}>{title}</div>
      <div className="mt-1.5 text-sm text-[var(--text-secondary)] max-w-md leading-relaxed">{body}</div>
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
